import type { SyncRecord } from '../../../components/CoSell/types'

export const mapSyncAttemptDirectionToSyncDirection = (
  direction: string | undefined | null
): SyncRecord['syncDirection'] => {
  const d = direction ?? ''
  return d === 'ace' ? 'crm_to_ace' : 'ace_to_crm'
}
